import { inject } from 'mobx-react';
import * as React from 'react';

import { AdvertisingStore } from 'bernie-plugin-ads-loader-script';
import { ErrorBoundary } from 'bernie-view';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';

import { DisplayAd } from 'constants/ads';
import { InfositePageName } from 'constants/pages';
import { PackageType } from 'models/multi-item/multi-item-types';

import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';

import { MesoDisplayAd } from './meso-display-ad';

interface MesoFooterProps {
  advertising?: AdvertisingStore;
}

@withLocalization
@inject('advertising')
export class MesoFooter extends React.Component<MesoFooterProps & LocalizedComponentProps> {
  public render() {
    const { advertising } = this.props;

    return Object.values(InfositePageName).some(val => val === advertising?.triggeredPageName) ? (
      <HISFooter pageName={advertising?.triggeredPageName} />
    ) : (
      <HSRFooter />
    );
  }
}

interface FooterProps {
  pageName?: string;
}

const HSRFooter: React.FunctionComponent<FooterProps> = () => (
  <ErrorBoundary label="meso.footer">
    <UitkSpacing padding={{ blockstart: 'six' }}>
      <UitkLayoutGrid justifyItems="center">
        <UitkLayoutGridItem>
          <MesoDisplayAd {...DisplayAd.FOOTER_CM1} />
        </UitkLayoutGridItem>
        <UitkLayoutGridItem>
          <MesoDisplayAd {...DisplayAd.FOOTER_CM2} />
        </UitkLayoutGridItem>
        <UitkLayoutGridItem>
          <MesoDisplayAd {...DisplayAd.FOOTER_CM3} />
        </UitkLayoutGridItem>
      </UitkLayoutGrid>
    </UitkSpacing>
  </ErrorBoundary>
);

const isPackagePath = (pageName: string): boolean =>
  Object.values(PackageType).some((packageName: string) => InfositePageName[packageName] === pageName);

const HISFooter: React.FunctionComponent<FooterProps> = ({ pageName }) => (
  <ErrorBoundary label="meso.footer">
    <UitkSpacing padding={{ block: 'four' }}>
      <UitkLayoutGrid justifyItems="center">
        <UitkLayoutGridItem>
          <MesoDisplayAd {...DisplayAd.FOOTER_CM1} />
        </UitkLayoutGridItem>
        <UitkLayoutGridItem>
          <MesoDisplayAd {...DisplayAd.FOOTER_CM2} />
        </UitkLayoutGridItem>
        <UitkLayoutGridItem>
          <MesoDisplayAd {...DisplayAd.FOOTER_CM3} />
        </UitkLayoutGridItem>
        <UitkLayoutGridItem>
          {isPackagePath(pageName) ? <MesoDisplayAd {...DisplayAd.FOOTER_CM4} /> : <MesoDisplayAd {...DisplayAd.FOOTER_CM6} />}
        </UitkLayoutGridItem>
      </UitkLayoutGrid>
    </UitkSpacing>
  </ErrorBoundary>
);
